
import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ArrayBooks from "../components/arrayBooks"
import HeadImage from "../components/headImage"
import { graphql } from "gatsby"
import yaml from "../data/pages/catalogue.data.yml"

const Article = ({ data }) => {
  return (
    <Layout>
      <SEO title={yaml.title} description={yaml.desc}/>
      <HeadImage fluid={data.file.childImageSharp.fluid} />
      <h2 className="mt-8">{yaml.title}</h2>
      <ArrayBooks books={data.allBooksJson.edges} className="mt-4" />
    </Layout>
  )
}

export default Article

export const pageQuery = graphql`
  query {
    allBooksJson(sort: {fields: datePublication, order: DESC}) {
      edges {
        node {
          slug
          title
          image {
            childImageSharp {
              fixed(width: 290) {
                base64
                height
                width
                src
                srcSet
                aspectRatio
              }
            }
          }
        }
      }
    }
    file(relativePath: {eq: "headImage-4.png"}) {
      childImageSharp {
        fluid(quality:90, maxWidth: 1280) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`